import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toMomentString } from "config/util";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
// import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";
import Select from "@material-ui/core/Select";

import { toValueLabel } from "Screen/Components/Basic/util";
import { t } from "../../services/i18n/index";
import MultiImageUpload from "../Components/Upload/MultiImageUpload";

const useStyles = makeStyles((theme) => ({
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
    width: "50%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  next_modal,
  accounts_auth_type,
  accounts,
  dispatch_danger,
  dispatch_put_accounts_security,
  dispatch_delete_accounts_images_id,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [two_factor_type, set_two_factor_type] = useState(
    `${accounts.two_factor_type}`
  );
  const [address01, set_address01] = useState(accounts.address01);
  const [address02, set_address02] = useState(accounts.address02);

  const [two_factor_flg, set_two_factor_flg] = useState(
    accounts.two_factor_flg
  );
  const classes = useStyles();

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {t("セキュリティ設定を変更")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <FormControl margin="dense" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label">
                    {t("通知先")}
                  </InputLabel>
                  <Select
                    labelId={t("通知先")}
                    id="demo-simple-select"
                    value={two_factor_type}
                    onChange={(event) => {
                      set_two_factor_type(event.target.value);
                    }}
                  >
                    {Object.keys(maps.two_factor_types).map((k) => {
                      return (
                        <MenuItem value={`${k}`}>
                          {t(maps.two_factor_types[k])}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <div>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={two_factor_flg}
                        color="primary"
                        name="checkedB"
                        inputProps={{ "aria-label": "primary checkbox" }}
                        onChange={(event) => {
                          set_two_factor_flg(event.target.checked);
                        }}
                      />
                    }
                    label={t("２ファクター認証")}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      dispatch_put_accounts_security(
                        {
                          two_factor_flg: two_factor_flg ? 1 : 0,
                          two_factor_type,
                        },
                        () => {
                          close_modal();
                        }
                      );
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
